module.exports = __webpack_public_path__ + "img/magnifying-glass-blue.af116267.svg";